import React, { useState } from 'react';
import { Section, Content } from '@layout';
import { H2 } from '@heading';
import Heart from './heart.svg';
import styles from './Intro.module.scss';
import PlayButton from './play-button.svg';
import classNames from 'classnames';

export default function Intro() {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Section
      className={styles.wrapper}
      wrapContent={false}
      fillContainer
    >
      <Content className={styles.content}>
        <p>
          We are a large, diverse and inclusive community of scholars from
          all walks of life. Together, we’re developing the current and
          future generations of leadership in green science.
        </p>
        <div className={styles.watchWrapper}>
          <strong className={styles.watch}>
            <span>Watch our video to learn more</span>
          </strong>

          <button
            className={styles.play}
            aria-label="Watch our video about The Center"
            onClick={() => {
              setHasLoaded(true);
              setIsVisible(isVisible => !isVisible);
            }}
          >
            <PlayButton />
          </button>

          <strong className={styles.videoTitle}>
            About The Center for Diverse Leadership in Science
          </strong>
        </div>
      </Content>

      {hasLoaded && (
        <div
          className={classNames(styles.videoWrapper, {
            [styles.visible]: isVisible
          })}
        >
          {isVisible && (
            <iframe
              className={styles.video}
              src="https://www.youtube.com/embed/bIon6onugsw?rel=0&amp;modestbranding=1&amp;autoplay=1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              title="CDLS Video"
              allowFullScreen
            />
          )}
        </div>
      )}
    </Section>
  );
}
